var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppFilter',{ref:"appFilter",on:{"apply":_vm.onFilter,"retainValues":_vm.retainFilter},model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }